// extracted by mini-css-extract-plugin
export var sliderRange = "_lj-2";
export var sliderRoot = "_lj-0";
export var sliderThumb = "_lj-3";
export var sliderTrack = "_lj-1";